/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Unmatched_ClearInputs */

const vi_warehouse_unmatched_clear = /** @type {(inputs: Warehouse_Unmatched_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá danh sách`)
};

/**

* @param {Warehouse_Unmatched_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_unmatched_clear = /** @type {((inputs?: Warehouse_Unmatched_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Unmatched_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_unmatched_clear(inputs)
});